export default "__VITE_ASSET__5b598f20__"